import * as actionTypes from './actionTypes'

export const loadVisitors_ = (data) => {

  return {
    type: actionTypes.GET_ALL_VISITORS,
    data: data
  }
};




